var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageBroadcastInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage_Broadcast_Inactive",
    "data-name": "Manage Broadcast_Inactive",
    transform: "translate(-48 -186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14863",
    "data-name": "Rectangle 14863",
    width: 24,
    height: 24,
    transform: "translate(48 186)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88384",
    "data-name": "Group 88384",
    transform: "translate(-12.463 -2.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88382",
    "data-name": "Group 88382",
    transform: "translate(67.513 195.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M1.084,7.793H.468V1.486a.774.774,0,1,1,.616,0V7.792h0Z",
    transform: "translate(4.173 4.173)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M1.208,5.2h0A2.919,2.919,0,0,1,0,2.861,2.861,2.861,0,0,1,5.721,2.79v.069A2.92,2.92,0,0,1,4.516,5.195l-.245-.416a2.22,2.22,0,0,0,.947-1.866A2.341,2.341,0,1,0,1.459,4.768l-.25.427Z",
    transform: "translate(2.087 2.086)",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M2.245,9.062h0A4.869,4.869,0,0,1,0,4.945,4.963,4.963,0,0,1,4.949,0h.018A4.934,4.934,0,0,1,9.724,3.647a4.688,4.688,0,0,1,.15,1.713,5.026,5.026,0,0,1-2.224,3.7L7.4,8.635A4.435,4.435,0,1,0,2.424,1.293,4.438,4.438,0,0,0,2.5,8.635l-.251.427Z",
    transform: "translate(0)",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55710",
    "data-name": "Group 55710",
    transform: "translate(62 190)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106386",
    "data-name": "Path 106386",
    d: "M112.134,30.114l-1.918-.482a8.393,8.393,0,0,0-.722-1.761l1.011-1.687a.436.436,0,0,0-.066-.532l-2.075-2.076a.435.435,0,0,0-.531-.066l-1.7,1.011a8.294,8.294,0,0,0-1.751-.724l-.483-1.923a.436.436,0,0,0-.423-.33h-2.943a.436.436,0,0,0-.423.33l-.483,1.915a8.728,8.728,0,0,0-1.752.726l-1.7-1.012a.435.435,0,0,0-.532.066L93.57,25.642a.437.437,0,0,0-.066.532l1.011,1.694a8.439,8.439,0,0,0-.734,1.763l-1.915.483a.436.436,0,0,0-.329.423v2.934a.435.435,0,0,0,.33.423l1.923.483a8.221,8.221,0,0,0,.724,1.751l-1.019,1.7a.436.436,0,0,0,.066.532l2.075,2.076a.435.435,0,0,0,.531.066l1.7-1.012a8.233,8.233,0,0,0,1.747.722l.491,1.928a.436.436,0,0,0,.423.328h2.934a.437.437,0,0,0,.423-.33l.482-1.924a7.939,7.939,0,0,0,1.751-.724l1.712,1.02a.436.436,0,0,0,.532-.067l2.066-2.075a.436.436,0,0,0,.066-.53l-1.014-1.714a8.664,8.664,0,0,0,.726-1.74l1.924-.483a.436.436,0,0,0,.33-.423V30.537a.436.436,0,0,0-.33-.423Zm-.542,3.025-1.841.462a.435.435,0,0,0-.316.315,7.767,7.767,0,0,1-.83,1.993.436.436,0,0,0,0,.441l.97,1.641-1.588,1.595-1.639-.977a.435.435,0,0,0-.447,0,7.084,7.084,0,0,1-1.991.822.436.436,0,0,0-.323.318l-.462,1.846H100.87l-.47-1.847a.436.436,0,0,0-.317-.315,7.377,7.377,0,0,1-1.992-.823.437.437,0,0,0-.446,0l-1.631.969-1.6-1.6.976-1.631a.437.437,0,0,0,0-.45,7.359,7.359,0,0,1-.827-2,.436.436,0,0,0-.316-.315L92.41,33.13V30.877l1.833-.462a.436.436,0,0,0,.316-.315,7.568,7.568,0,0,1,.837-2.011.437.437,0,0,0,0-.447l-.968-1.622,1.595-1.595,1.622.968a.434.434,0,0,0,.443,0,7.861,7.861,0,0,1,2.007-.831.436.436,0,0,0,.315-.316l.462-1.833h2.263l.462,1.841a.435.435,0,0,0,.315.316,7.38,7.38,0,0,1,2,.827.436.436,0,0,0,.448,0l1.631-.969,1.6,1.6-.967,1.614a.436.436,0,0,0,0,.445,7.547,7.547,0,0,1,.824,2.011.436.436,0,0,0,.317.318l1.837.462Z",
    transform: "translate(-91.538 -21.543)",
    fill: "#262626"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageBroadcastInactive);
export default __webpack_public_path__ + "static/media/manage_broadcast_inactive.cb5995dd.svg";
export { ForwardRef as ReactComponent };